import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-table-6/react-table.css'
import "./assets/scss/material-dashboard-pro-react.scss?v=1.5.0";
import './index.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
  <>
    <ToastContainer autoClose={2500} />
    <App />
  </>,document.getElementById('root')
);
